import * as React from 'react';

import GamerTag from './GamerTag.jsx';

import { useApplication } from '../AppContext';

const PlayerTag = (props) => {
	const app = useApplication();
	const userdata = app.userdata;

	const playerInfo = React.useMemo(() => ({
		name: userdata?.name ?? '',
		avatar: userdata?.avatar ?? 'assets/Avatars/vv/AvatarVV_0071.png',
		achievementProgress: userdata?.achievementProgress ?? 0,
		inviteCode: userdata?.id ?? '',
		coins: userdata?.coins ?? 0,
	}), [userdata?.name, userdata?.avatar, userdata?.achievementProgress, userdata?.id, userdata?.coins]);

	return (
		<GamerTag player={playerInfo} {...props} />
	);
};

export default PlayerTag;
